import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Link } from 'src/app/reports/shared/link/models/link.model';
import { LinkGroup } from 'src/app/reports/shared/link/models/link-group.model';
import { RelatedEntity } from '../../../../models/related-entity.model';
import { ObjectValue } from 'src/app/reports/models/object-value.model';
import { JoinTypeEnum } from 'src/app/reports/enums/join-type.enum';

@Component({
  selector: 'app-relation-options',
  templateUrl: './relation-options.component.html',
  styleUrls: ['./relation-options.component.scss']
})
export class RelationOptionsComponent implements OnInit {

  @ViewChild('content', {read: ElementRef}) content: ElementRef;

  @Input() link: Link;
  @Input() relation: RelatedEntity;
  @Input() disabled: boolean;

  @Output() delete = new EventEmitter<Link>();

  linkGroup: LinkGroup;
  isActive = false;
  joinOptions: ObjectValue[] = [];

  constructor(public elm: ElementRef) { }

  //#region Interface Implementations

  ngOnInit() {
    this.joinOptions = [
      new ObjectValue('Inner Join', JoinTypeEnum.Inner),
      new ObjectValue('Left Join', JoinTypeEnum.Left),
      new ObjectValue('Rigth Join', JoinTypeEnum.Righ),
      new ObjectValue('Outer Join', JoinTypeEnum.Outer),
    ];
  }

  //#endregion

  //#region Events

  deleteClick(event) {
    this.delete.emit(this.link);
  }

  closeMoreOptions() {
    this.isActive = false;
  }

  //#endregion

  get header(): string {
    return `${this.relation.EntityAlias}.${this.relation.ColumnName} = ` +
    `${this.relation.RelatedEntityAlias}.${this.relation.RelatedColumnName}`;
  }
}
